localizeCount = require 'lib/localize-count'
React = require 'react'
l = require 'lib/localize'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_sidebar')

module.exports = class SidebarComponent extends React.Component
  render: t.renderable ->
    {
      teamsCount, membersCount, selectedTab, onSidebarTabClick,
      enterpriseMembersCount, enterpriseMaxMembers,
      outsideCollaboratorsCount, ssoUsersCount, deactivatedCount,
      nearMaxMembers, exceedingMaxMembers,
      userTypesLoaded, pendingRequestsCount
    } = @props

    t.div ->
      t.div '.enterprise-dash-sidebar', ->
        t.div '.header', ->
          t.format 'enterprise-administration'

        t.hr()

        isEnglish = /^en/.test(window.locale)

        t.ul ->
          t.li ->
            t.b ->
              onSidebarTabClick('teams')
            , '.link', { class: t.classify('is-active': selectedTab == 'teams') }, ->
              t.text l ['view title', 'teams']
              if pendingRequestsCount > 0
                t.span '.pending-requests-count.quiet', ->
                  t.text ' '
                  t.format 'pending-requests-count', { pendingRequestsCount }

          t.li ->
            t.b ->
              onSidebarTabClick('members')
            , '.link', { class: t.classify('is-active': selectedTab == 'members') }, ->
              t.text l ['view title', 'members']

        t.div '.enterprise-dash-stats',
          class: t.classify
            'seat-limit-near': nearMaxMembers
            'seat-limit-exceeded': exceedingMaxMembers
        , ->
          unless userTypesLoaded
            t.div '.spinner', { title: 'Loading statistics…' }
            return

          t.p ->
            # temporary quick fix for English only
            _translate = (string) ->
              seatsCount = localizeCount('seats', enterpriseMaxMembers)
              unusedSeatsCount = localizeCount('seats', enterpriseMaxMembers - enterpriseMembersCount)
              membersCount =
                if isEnglish
                  if enterpriseMembersCount == 1
                    'one billable team member'
                  else
                    "#{enterpriseMembersCount} billable team members"
                else
                  localizeCount('members', enterpriseMembersCount)

              t.format string, { membersCount, seatsCount, unusedSeatsCount }

            if enterpriseMaxMembers?
              unusedSeatsCount = enterpriseMaxMembers - enterpriseMembersCount
              if exceedingMaxMembers
                _translate 'member-count-exceeding-seat-limit'
              else if unusedSeatsCount == 0
                _translate 'member-count-at-seat-limit'
              else if nearMaxMembers
                _translate 'member-count-nearing-seat-limit'
              else
                _translate 'member-count-with-seat-limit'
            else
              _translate 'member-count'

          if isEnglish && deactivatedCount
            t.p ->
              t.text localizeCount('deactivated count', deactivatedCount)

          if outsideCollaboratorsCount || ssoUsersCount
            t.p ->
              if outsideCollaboratorsCount && ssoUsersCount
                t.format 'collaborators-and-sso-users-count',
                  outsideCollaboratorsCount: localizeCount(
                    'outside collaborators',
                    outsideCollaboratorsCount
                  )
                  ssoUsersCount: localizeCount(
                    'sso users',
                    ssoUsersCount
                  )
              else if outsideCollaboratorsCount
                t.format 'collaborators-count',
                  outsideCollaboratorsCount: localizeCount(
                    'outside collaborators',
                    outsideCollaboratorsCount
                  )
              else if ssoUsersCount
                t.format 'sso-users-count',
                  ssoUsersCount: localizeCount(
                    'sso users',
                    ssoUsersCount
                  )

              t.format 'theyre-free'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/sidebar-component.coffee